import * as angular from "angular";
import { EmploymentStatusService } from "../services/employment-status.service";

export class EmploymentStatusDataProvider {
    private $q: any;
    private resource: EmploymentStatusService;

    constructor($q: any, EmploymentStatusService: EmploymentStatusService) {
        this.$q = $q;
        this.resource = EmploymentStatusService;
    }

    all(): Promise<any> {
        const deferred = this.$q.defer();
        this.resource.all().then(
            (response: object) => {
                let json = response["data"];
                if (json.success) {
                    deferred.resolve(json.data);
                } else {
                    deferred.reject(json);
                }
            },
            (error: object) => deferred.reject(error)
        );
        return deferred.promise;
    }
}

angular
    .module("vcDataProvider")
    .service("EmploymentStatusDataProvider", EmploymentStatusDataProvider);
